
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Dashboard"
})
export default class extends Vue {

}
